<template>
    <page>
        <template #title>{{$t('pages.dashboard.account.address.title')}}</template>

        <template #content>
            <m-form-organization-edit-without-member-id v-if="organizationIdentifierName"/>
            <div v-else>
                <div class="create-new-organisation-identifier">
                    <v-layout wrap>
                        <v-flex xs-12>
                            <e-typography-body>
                                {{$t('pages.dashboard.account.address.needIdentifier')}}
                            </e-typography-body>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <e-button-primary :to="nav.dashboard.account.createIdentifier.path()"
                                              class="create-new-organisation-identifier__button">
                                {{$t('pages.dashboard.account.address.createIdentifier')}}
                            </e-button-primary>
                        </v-flex>
                    </v-layout>
                </div>
                <div class="hide-trades-form">
                    <m-form-organization-edit-without-member-id/>
                </div>
            </div>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import MFormOrganizationEditWithoutMemberId from "@modules/forms/concrete/m-form-organization-edit-without-member-id";
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "dashboard-account-address",
        components: {Page, MFormOrganizationEditWithoutMemberId},
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.account.address.meta.title')
            }
        },
        methods: {
            ...mapActions({
                requestOrganization: 'organizations/read',
            }),
        },
        computed: {
            ...mapGetters({
                getUser: "users/read",
                getOrganization: 'organizations/read'
            }),
            organizationId() {
                return this.$user.relationships.organization.data.id;
            },
            organization() {
                return this.getOrganization(this.organizationId)
            },
            organizationIdentifierName() {
                return this.organization.identifierName
            },
        },
        async created() {
            if (!this.organization.length) {
                await this.requestOrganization({id: this.organizationId});
            }
        },
    }
</script>

<style lang="scss" scoped>
    .hide-trades-form{
        position: relative;
        margin-top: 2rem;
        &::after {
            content:'';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: var(--v-secondary-base);
            opacity: .5;
        }
    }
</style>
